import { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Button, Stack,
} from '@mui/material';
import intl from 'components/i18n/ReactIntlWrapper';
import ResizableDrawer from 'components/Layout/ResizableDrawer';

interface Props {
  open: boolean;
  onClose: () => void;
  onSave: (data: any) => Promise<void>;
  item: any;
}

const TrainingCertificationDrawer: React.FC<Props> = ({ open, onClose, onSave, item }) => {
  const [form, setForm] = useState({ name: '', description: '', price: '', url: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm({
      name: item?.name ?? '',
      description: item?.description ?? '',
      price: item?.price?.toString() ?? '',
      url: item?.url ?? '',
    });
  }, [item, open]);

  const set = (key: string) => (e: React.ChangeEvent<HTMLInputElement>) =>
    setForm((f) => ({ ...f, [key]: e.target.value }));

  const handleSave = async () => {
    if (!form.name.trim()) return;
    setSaving(true);
    try {
      await onSave({
        name: form.name.trim(),
        description: form.description.trim() || null,
        price: form.price ? parseFloat(form.price) : null,
        url: form.url.trim() || null,
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <ResizableDrawer open={open} onClose={onClose} defaultWidth={440}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        {item ? intl.get('hr.certification.edit') : intl.get('hr.certification.add')}
      </Typography>
      <Box component="form" onSubmit={(e) => { e.preventDefault(); handleSave(); }}>
        <TextField label={intl.get('hr.certification.name')} value={form.name} onChange={set('name')} fullWidth required sx={{ mb: 2 }} />
        <TextField label={intl.get('hr.certification.description')} value={form.description} onChange={set('description')} fullWidth multiline rows={3} sx={{ mb: 2 }} />
        <TextField label={intl.get('hr.certification.price')} value={form.price} onChange={set('price')} fullWidth type="number" inputProps={{ min: 0, step: '0.01' }} sx={{ mb: 2 }} />
        <TextField label={intl.get('hr.certification.url')} value={form.url} onChange={set('url')} fullWidth sx={{ mb: 3 }} />
        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button onClick={onClose}>{intl.get('common.cancel')}</Button>
          <Button type="submit" variant="contained" disabled={saving}>{intl.get('common.save')}</Button>
        </Stack>
      </Box>
    </ResizableDrawer>
  );
};

export default TrainingCertificationDrawer;
